import * as React from "react"
import useDebouncedCallback from "./debounce-callback.js"

const valueEquality = (left, right) => left === right

// https://github.com/xnimorz/use-debounce/blob/master/src/useDebounce.ts
const useDebounce = (value, delay, options) => {
  const eq = options && options.equalityFn ? options.equalityFn : valueEquality

  const [state, dispatch] = React.useState(value)
  const [callback, cancel, callPending] = useDebouncedCallback(
    React.useCallback(value => dispatch(value), []),
    delay,
    options
  )
  const previousValue = React.useRef(value)

  React.useEffect(() => {
    // We need to use this condition otherwise we will run debounce timer for the first render (including maxWait option)
    if (!eq(previousValue.current, value)) {
      callback(value)
      previousValue.current = value
    }
  }, [value, callback, eq])

  return [state, cancel, callPending]
}

export default useDebounce
